// Tile-level elements
export const Z_SELECTION_OVERLAY = 10;
export const Z_SELECTION_CHECKMARK = 20;

// Sticky page elements (above tile content)
export const Z_STATUS_SECTION_HEADER = 30;
export const Z_COMMAND_BAR = 40;
export const Z_PAGE_TABS = 50;
export const Z_PAGE_HEADER = 60;
export const Z_BULK_ACTIONS = 70;

// The mobile bottom nav replaces the left nav below 768px. It is kept under the
// shadcn modal layer (z-50: dialogs, sheets and their scrims) so its own More sheet
// and any dialog cover it. The sticky elements above it in this scale sit at the
// top of the page and never overlap it; the bulk actions bar moves up to clear it.
export const Z_MOBILE_BOTTOM_NAV = 45;

// Overlays (above all sticky page elements)
export const Z_LIGHTBOX = 75;

// Ask Adora, above the lightbox. The trigger is offered *from* a lightbox on
// Generate Creatives, Review Ads and Reporting, so all three of its layers have
// to clear `Z_LIGHTBOX` — a drawer or scrim left below it would open behind the
// lightbox's opaque backdrop and be invisible exactly where the trigger is used.
// The trigger itself is topmost of the three: it stays mounted as the "Close"
// pill while the drawer is open, so it has to ride above the drawer (78) rather
// than being covered by it.
export const Z_AGENT_CHAT_SCRIM = 76;
export const Z_AGENT_CHAT_DRAWER = 78;
export const Z_ASK_ADORA_TRIGGER = 80;

// A tray the mobile bottom nav opens (and its scrim) covers the page header and
// the Ask Adora trigger. Below the immersive editor, the tour and toasts.
export const Z_MOBILE_NAV_TRAY = 81;

// The immersive image editor is a full-screen editing mode entered from a
// lightbox (which closes behind it). It sits above the Ask Adora trigger so that
// the floating button stays out of a surface whose whole point is close work on
// one image — it was covered when the editor shared `Z_LIGHTBOX`, and moving the
// lightbox below Ask Adora would otherwise have surfaced it.
export const Z_IMMERSIVE_EDITOR = 82;

// The product tour sits above Ask Adora so it can point at the trigger:
// spotlight and highlight at 85, tooltip at 90. Both are Tailwind literals
// (`z-[85]`/`z-[90]`) in the product-tour components — Tailwind cannot compile a
// class from a runtime value — so they are recorded here rather than exported.

export const Z_TOAST = 95;

// Content portaled inside a dialog. DialogContent is z-100, so dropdowns,
// popovers, and menus opened from within a dialog must sit above it
// (matches shadcn SelectContent's z-150).
export const Z_DIALOG_POPOVER = 150;

// A confirmation can open from inside a Flux (MUI) dialog, which sits at 1300
// (MUI's modal layer), or from a template overlay dialog (1500). It sits above
// both, below the template slot menus (1600). Its Flux hosts set
// `disableEnforceFocus`, so MUI doesn't pull focus back out of it.
export const Z_CONFIRMATION_DIALOG = 1550;
